module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('h2', [_vm._v("我的报告\n    "), (_vm.report.abilities.length !== 0 && _vm.need_refresh !== 1) ? _c('span', {
    staticClass: "btn btn-primary right",
    on: {
      "click": function($event) {
        _vm.download()
      }
    }
  }, [_vm._v("下载报告")]) : _vm._e(), _vm._v(" "), (_vm.need_refresh === 1) ? _c('span', {
    staticClass: "btn btn-primary right",
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  }, [_vm._v("重新生成")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "report-area"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "b-b m-b-sm"
  }), _vm._v(" "), (_vm.loading === 1) ? _c('loading') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === 0),
      expression: "loading === 0"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.abilities.length === 0),
      expression: "report.abilities.length === 0"
    }],
    staticClass: "tips"
  }, [_vm._v("\n          您暂未获得测评数据，请前往\n          "), _c('router-link', {
    attrs: {
      "to": "/evaluate"
    }
  }, [_vm._v("测评中心")]), _vm._v("进行素质测评，生成测评数据。\n        ")], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report.abilities.length !== 0),
      expression: "report.abilities.length !== 0"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row user-info p-t-b-sm snapshort"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.user.realname))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("邮箱:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), (_vm.user.phone) ? _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("手机:")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.user.phone))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('img', {
    staticClass: "m-r-sm right",
    attrs: {
      "src": _vm.user.avatar,
      "alt": "",
      "width": "100"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "b-b m-b-sm"
  })]), _vm._v(" "), (_vm.report.abilities && _vm.report.abilities.length >= 3) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('radar', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "title": _vm.radar_data.title,
      "legend": _vm.radar_data.legend,
      "series": _vm.radar_data.series,
      "indicator": _vm.radar_data.indicator
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b-b"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.report.abilities && _vm.report.abilities.length >= 3) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": "bar-area"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b-b m-b-sm"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail_data === 0),
      expression: "detail_data === 0"
    }],
    staticClass: "row"
  }, _vm._l((_vm.report.abilities), function(ability, ind) {
    return _c('div', {
      key: ability._id,
      staticClass: "col-xs-12 m-t-b-sm ability snapshort",
      class: {
        'open': ability.is_open === 1
      }
    }, [_c('div', {
      staticClass: "btn btn-md n-b-r col-xs-12 n-f btn-success"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-3"
    }, [_c('span', [_vm._v("能力名称：")]), _vm._v(" "), _c('span', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(ability.ability.name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "detail col-xs-12"
    }, [_c('div', {
      staticClass: "row p-b-sm"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-4"
    }, [_c('div', {
      staticClass: "row"
    }, [(ability.ability.desc) ? _c('div', {
      staticClass: " p-t-b-sm"
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(ability.ability.desc)
      }
    })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-4"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('Scatter', {
      staticClass: "col-xs-12 n-p-l n-p-r",
      staticStyle: {
        "height": "200px"
      },
      attrs: {
        "type": 2,
        "target": ability.ability._id,
        "name": ability.ability.name,
        "score": ability.score,
        "rate": ability.rate
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 m-t-xs text-center p-b-xs",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('span', {
      staticClass: "score"
    }, [_vm._v(_vm._s(ability.score.toFixed(2)) + "分")]), _vm._v(",领先\n                        "), _c('span', {
      staticClass: "score"
    }, [_vm._v(_vm._s((ability.rate * 100).toFixed(2)) + "%")]), _vm._v("的用户")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-4"
    }, [_c('div', {
      staticClass: "row"
    }, [(ability.grade_desc) ? _c('div', {
      staticClass: "col-xs-12 p-t-b-sm"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("解析：")]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(ability.grade_desc)
      }
    })]) : _vm._e(), _vm._v(" "), (ability.grade_suggestion) ? _c('div', {
      staticClass: "col-xs-12 p-t-b-sm"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("建议：")]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(ability.grade_suggestion)
      }
    })]) : _vm._e(), _vm._v(" "), (ability.grade_improvement) ? _c('div', {
      staticClass: "col-xs-12 p-t-b-sm"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("改善：")]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(ability.grade_improvement)
      }
    })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "b-b"
    }), _vm._v(" "), (ability.indicators.length >= 3) ? _c('div', {
      staticClass: "row p-b-sm"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('radar', {
      staticClass: "col-xs-12",
      staticStyle: {
        "height": "300px"
      },
      attrs: {
        "title": ability.radar_data.title,
        "legend": ability.radar_data.legend,
        "series": ability.radar_data.series,
        "indicator": ability.radar_data.indicator
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "b-b clearfix"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row p-b-sm"
    }, _vm._l((ability.indicators), function(indicator) {
      return _c('div', {
        key: indicator._id,
        staticClass: "indicator col-xs-12 m-b-sm",
        class: {
          'col-sm-4': ability.indicators.length >= 3 || ability.indicators.length === 1, 'col-sm-6': ability.indicators.length === 2
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('Scatter', {
        staticClass: "col-xs-12 n-p-l n-p-r",
        staticStyle: {
          "height": "200px"
        },
        attrs: {
          "type": 1,
          "target": indicator.indicator._id,
          "name": indicator.indicator.name,
          "score": indicator.score,
          "rate": indicator.rate
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 m-t-xs text-center p-b-xs",
        staticStyle: {
          "font-size": "14px"
        }
      }, [_c('span', {
        staticClass: "score"
      }, [_vm._v(_vm._s(indicator.score.toFixed(2)) + "分")]), _vm._v(",领先\n                        "), _c('span', {
        staticClass: "score"
      }, [_vm._v(_vm._s((indicator.rate * 100).toFixed(2)) + "%")]), _vm._v("的用户")]), _vm._v(" "), (indicator.grade_desc) ? _c('div', {
        staticClass: " p-t-b-sm"
      }, [_c('div', {
        staticClass: "col-xs-12"
      }, [_c('div', {
        staticClass: "row p-l-r-xs"
      }, [_c('div', {
        staticClass: "label"
      }, [_vm._v("指标解析：")]), _vm._v(" "), _c('div', {
        staticClass: "desc",
        domProps: {
          "innerHTML": _vm._s(indicator.grade_desc)
        }
      })])])]) : _vm._e()], 1)])
    }))])])
  })), _vm._v(" "), _vm._m(1)])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 m-b-sm"
  }, [_c('div', {
    staticStyle: {
      "height": "20px",
      "background": "#42b983"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('img', {
    staticClass: "psych-logo left",
    attrs: {
      "src": "/assets/images/psych2_4_2.jpg",
      "alt": "",
      "height": "60"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('img', {
    staticClass: "lechenggu-logo left right",
    attrs: {
      "src": "/assets/images/lechenggu-logo.png",
      "alt": "",
      "height": "60"
    }
  })])])]), _vm._v(" "), _c('h1', {
    staticClass: "p-t-b-md n-m-b text-center"
  }, [_vm._v("个人测评报告")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_c('span', [_vm._v("本报告由")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "href": "http://www.psych.cas.cn",
      "title": "中国科学院心理研究所·心理健康应用中心",
      "alt": "中国科学院心理研究所·心理健康应用中心"
    }
  }, [_vm._v("中国科学院心理研究所·心理健康应用中心")]), _vm._v(" "), _c('span', [_vm._v("提供测评技术支持")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 m-b-sm"
  }, [_c('div', {
    staticStyle: {
      "height": "20px",
      "background": "#42b983"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8e60c74","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/report.vue
// module id = 501
// module chunks = 1